"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalOffsetCalculation = void 0;
const getScrollBarWidth_1 = require("./getScrollBarWidth");
const totalOffsetCalculation = (rootWidth, hasScroll, columnsToggleable) => {
    const scrollBarWidth = (0, getScrollBarWidth_1.getScrollBarWidth)();
    const hasScrollBar = scrollBarWidth !== 0;
    const buttonWidth = 32;
    let headerOffset = 0;
    let bodyOffset = 0;
    let availableBodyWidth = rootWidth;
    if (columnsToggleable) {
        headerOffset = buttonWidth;
        bodyOffset = buttonWidth;
        availableBodyWidth = rootWidth - buttonWidth;
        if (hasScroll && hasScrollBar) {
            bodyOffset -= scrollBarWidth;
        }
    }
    else if (hasScroll && hasScrollBar) {
        headerOffset = scrollBarWidth;
        availableBodyWidth = rootWidth - scrollBarWidth;
    }
    return { headerOffset, bodyOffset, availableBodyWidth };
};
exports.totalOffsetCalculation = totalOffsetCalculation;
//# sourceMappingURL=totalOffsetCalculation.js.map